import React from 'react';

const Title = () => {
  return (
    <h1>Personal Performance Tracker</h1>
  );
}

export default Title;
